module.exports = __webpack_public_path__ + "static/media/SB3.ac63ed94.png";